import React from 'react'
import { Flex, FlexProps, Link, Text } from '@chakra-ui/react'
import { chakra } from '@chakra-ui/system'
import { ArrowRight } from '@emotion-icons/heroicons-outline/ArrowRight'
import { AuthorInfo } from 'entities/blog'
import { routes } from 'routes'
import { Avatar } from 'components/images/Avatar'

const ArrowRightIcon = chakra(ArrowRight)

export const AboutAuthor = ({
    name,
    summary,
    imageUrl,
    ...flexProps
}: Pick<AuthorInfo, 'name' | 'summary' | 'imageUrl'> & FlexProps) => {
    return (
        <Flex gridGap={{ base: '16px', lg: '24px' }} {...flexProps}>
            <Avatar src={imageUrl} boxSize={'68px'} />

            <Flex direction="column" gridGap={{ base: '2px', lg: '4px' }}>
                <Text variant="bodyTextSmall" fontWeight={600}>
                    {name}
                </Text>
                <Text variant="bodyTextSmall" noOfLines={5}>
                    {summary}
                </Text>
                <Link
                    href={routes.articlesByAuthor(name)}
                    display="flex"
                    alignItems="center"
                    gridGap="8px"
                >
                    <Text variant="functionalSemiBold" color="secondary.text">
                        See other articles by {name.split(' ')[0]}
                    </Text>
                    <ArrowRightIcon
                        boxSize="19px"
                        strokeWidth={1.5}
                        color="secondary.text"
                    />
                </Link>
            </Flex>
        </Flex>
    )
}
